import styled, { css } from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

export const CollapseContainer = styled.div`
  max-width: 100%;

  outline: 0;
  border: none;
  border-radius: 8px;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 14px;
  transition: all 0.65s;
  background-color: ${theme.colors.primary.white};

  & + div {
    margin-top: 24px;
  }
`;

interface IAccordion {
  inside?: boolean;
  insideTwo?: boolean;
  isOpen?: boolean;
  noBorder?: boolean;
  paddingAccordion?: string;
  marginAccordion?: string;
  paddingItem?: string;
  marginItem?: string;
  smallWidth?: boolean;
  isCapitalizeText?: boolean;
}

export const Accordion = styled.div<IAccordion>`
  color: ${theme.colors.secondary.gray200};
  padding: ${({ paddingAccordion }) => (paddingAccordion ? paddingAccordion : '16px 24px 40px 32px')};
  border: ${({ noBorder }) => (noBorder ? 'none' : `1px solid ${theme.colors.primary.transparentBorder}`)};
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (max-width: 1600px) {
    ${({ smallWidth }) =>
      smallWidth &&
      css`
        width: 70%;
      `}
  }

  ${({ inside }) =>
    inside &&
    css`
      padding: 32px 0 !important;
      border-color: transparent;
    `}

  ${({ isOpen }) =>
    !isOpen &&
    css`
      &:hover {
        background: ${theme.colors.secondary.gray600};
      }
    `}
`;

export const AccordionContent = styled.div<IAccordion>`
  cursor: pointer;
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;
  position: relative;
  width: 100%;
  text-transform: ${({ isCapitalizeText }) => isCapitalizeText && 'capitalize'};
`;

export const IconContainer = styled.div`
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  font-size: 32px;
  line-height: 100%;
  height: 100%;
  color: ${theme.colors.secondary.gray300};
  padding-right: 24px;
`;

export const AccordionContentText = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
`;

export const AccordionHead = styled.div`
  flex-direction: column;
  margin-right: 16px;
  width: 100%;
`;

export const AccordionTitle = styled.h2`
  font-size: 15px;
  line-height: 24px;
  font-weight: ${theme.weights.bold};
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: ${theme.colors.primary.black};
`;

export const Counter = styled.span`
  color: ${theme.colors.primary.bariBlue};
  letter-spacing: 0.01em;
  margin-left: 4px;
  padding-right: 24px;
`;

export const AccordionSubTitle = styled.p`
  font-size: 14px;
  line-height: 32px;
  color: ${theme.colors.secondary.gray300};
`;

export const BadgeContainer = styled.div`
  align-items: center;

  label {
    height: 30px;
    width: max-content;
  }
`;

export const OptionsContainer = styled.div`
  margin-left: 8px;
`;

export const AccordionAction = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
  width: 32px;
  height: 32px;

  svg {
    margin-left: 8px;

    path {
      fill: ${theme.colors.primary.black};
    }
  }
`;

export const AccordionItem = styled.div<IAccordion>`
  overflow: unset;
  opacity: 1;
  transition: all 0.3s cubic-bezier(1, 0, 1, 0);
  height: auto;
  width: 100%;
  max-height: 9999px;
  flex-direction: column;

  ${({ isOpen }) =>
    !isOpen &&
    css`
      max-height: 0;
      margin-top: 0;
      transition: all 0.35s cubic-bezier(0, 1, 0, 1);
      opacity: 0;
      overflow: hidden;
      padding: '0px';
    `}

  ${({ inside }) =>
    inside &&
    css`
      padding-left: 61px;
    `}

  ${({ insideTwo }) =>
    insideTwo &&
    css`
      padding: 0;
      border: none;
      margin-top: 24px;
    `}
  ${({ isOpen, paddingItem }) =>
    isOpen &&
    css`
      padding: ${paddingItem};
    `}

  & > div {
    margin: ${({ marginItem }) => marginItem};
  }
`;
